import React from 'react';
import { Button } from 'Permafrost/components/ui-foundations/buttons/Button/Button';
import { StyledFilterSelectControls } from './FilterSelectControls.styles';
export const FilterSelectControls = ({ currentStoreFilters, selectedFilters, onSave, setIsOpen, setSelectedFilters, }) => {
    return (React.createElement(StyledFilterSelectControls, null,
        React.createElement(Button, { "aria-label": "Apply filter button", className: "apply-btn", onClick: () => {
                onSave(selectedFilters);
                setIsOpen(false);
            } }, "Apply"),
        React.createElement(Button, { "aria-label": "Cancel filter button", className: "cancel-btn", onClick: () => {
                setSelectedFilters(currentStoreFilters);
                setIsOpen(false);
            } }, "Cancel")));
};
//# sourceMappingURL=FilterSelectControls.js.map